// extracted by mini-css-extract-plugin
export var cancelButton = "_of-5";
export var content = "_of-3";
export var createButton = "_of-6";
export var drawerContainer = "_of-0";
export var footer = "_of-2";
export var header = "_of-1";
export var orderFormColumn = "_of-4";